/* eslint-disable class-methods-use-this */
import http from './BaseRequest';
import {
  getAuthTokenFromLocalStorage,
  getAuthUserFromLocalStorage,
} from '../helper';

export type TApiResponse<T> = {
  code: number;
  message: string;
  data: T;
};

export type TApiPaginationResponse<T> = {
  offset: number;
  limit: number;
  totalDocs: number;
  docs: Array<T>;
};

export class APIDataProvider {
  // eslint-disable-next-line
  post<T>(path: string, data: any): Promise<T> {
    const token = getAuthTokenFromLocalStorage();
    const authUser = getAuthUserFromLocalStorage();

    if (token) {
      http.defaults.headers.common.Authorization = `Bearer ${token}`;
    }

    if (authUser) {
      http.defaults.headers.common['user-id'] = authUser._id;
    }

    return http
      .post(path, data)
      .then((res) => res.data as T)
      .catch((err) => {
        return Promise.reject(new Error(JSON.stringify(err.response)));
      });
  }

  get<T>(path: string): Promise<T> {
    const token = getAuthTokenFromLocalStorage();
    const authUser = getAuthUserFromLocalStorage();

    if (token) {
      http.defaults.headers.common.Authorization = `Bearer ${token}`;
    }

    if (authUser) {
      http.defaults.headers.common['user-id'] = authUser._id;
    }

    return http
      .get(path)
      .then((res) => res.data as T)
      .catch((err) => {
        return Promise.reject(new Error(JSON.stringify(err.response)));
      });
  }

  // eslint-disable-next-line
  put<T>(path: string, data: any): Promise<T> {
    const token = getAuthTokenFromLocalStorage();
    const authUser = getAuthUserFromLocalStorage();

    if (token) {
      http.defaults.headers.common.Authorization = `Bearer ${token}`;
    }

    if (authUser) {
      http.defaults.headers.common['user-id'] = authUser._id;
    }

    return http
      .put(path, data)
      .then((res) => res.data as T)
      .catch((err) => {
        return Promise.reject(new Error(JSON.stringify(err.response)));
      });
  }

  delete<T>(path: string): Promise<T> {
    const token = getAuthTokenFromLocalStorage();
    const authUser = getAuthUserFromLocalStorage();

    if (token) {
      http.defaults.headers.common.Authorization = `Bearer ${token}`;
    }

    if (authUser) {
      http.defaults.headers.common['user-id'] = authUser._id;
    }

    return http
      .delete(path)
      .then((res) => res.data as T)
      .catch((err) => {
        return Promise.reject(new Error(JSON.stringify(err.response)));
      });
  }
}

export default APIDataProvider;
